import { render } from "./shopList.vue?vue&type=template&id=08837983"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/shop/shopList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08837983"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08837983', __exports__)) {
    console.log('reload')
    api.reload('08837983', __exports__)
  }
  
  module.hot.accept("./shopList.vue?vue&type=template&id=08837983", () => {
    console.log('re-render')
    api.rerender('08837983', render)
  })

}


export default __exports__